import * as React from 'react'

interface IButtonWithIconProps {
  title: string
  children?: any
}

const ButtonBlueWithIcon = (props: IButtonWithIconProps) => {
  return (
    <div className='ml2 bg-white cursor--pointer'>
      <div className='flex items-center py1 px1 border-blue-grey rounded'>
        {props.children}
        <span className='h6 bold font-blue-grey ml1'>{props.title}</span>
      </div>
    </div>
  )
}

export default ButtonBlueWithIcon



// WEBPACK FOOTER //
// ./src/components/ui/ButtonBlueWithIcon.tsx